import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-page" }
const _hoisted_2 = { class: "p-help l-container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"p-help__ttl--primary c-ttl--primary\">よくあるご質問</h1><section id=\"help_01\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">集英社IDとは？</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">株式会社集英社が運営するサービスをより便利に、そして強固なセキュリティでより安全にご利用いただくためのアカウントIDです。<br> 集英社IDをご利用いただくことで、弊社が提供するサービスが同じIDとパスワードでスムーズにご利用いただくことができます。</p><p class=\"p-help__txt\">現在（2025年12月16日時点）、以下のサイトやアプリが同じID（集英社ID）とパスワードでご利用いただけます。</p><ul class=\"p-help__list p-help__list--01\"><li>集英社の公式ファッション通販サイト「HAPPY PLUS STORE」</li><li>ファッション情報発信をしているサイト「HAPPY PLUS （ハピプラ）」</li><li>ジャンプキャラクターグッズの通販サイト「ジャンプキャラクターズストア」</li><li>ジャンプの情報を自分好みに、わかりやすくナビゲーションするアプリ「ジャンプNAVI」</li><li>動画コンテンツを提供するオンライン講座課金型サイト「HAPPY PLUS ACADEMIA」</li><li>LEEの情報発信をしているサイト「LEE」</li><li>豪華賞品の応募ができるキャンペーンサイト「年末年始 集英社マンガ祭」</li><li>文化系男子のためのウェブサイト「UOMO」</li><li>雑誌「週刊プレイボーイ」の公式総合エンタメサイト「週プレNEWS」</li><li>集英社の総合スポーツコラムメディア「webスポルティーバ」</li><li>男性ファッション誌「メンズノンノ」の公式サイト「MEN&#39;S NON-NO WEB」</li><li>集英社少女・女性向けマンガポータルサイト「リマコミ＋」</li><li>ウェブニュースメディア「集英社オンライン」</li><li>集英社のゲーム・カード・ホビー月刊情報誌「Ｖジャンプ」</li><li>集英社の少女・女性向けマンガアプリ「マンガMee」</li><li>新刊紹介や試し読み、インタビュー、エッセイ、書評など、集英社書籍の魅力を伝える公式総合メディア「集英社書籍」</li><li>集英社の少女まんが雑誌「別冊マーガレット」</li><li>ファッションからラグジュアリーアイテム、ライフスタイルからエンターテインメントまで情報をお届けするウェブサイト「SPUR（シュプール）」</li></ul></div></div></section><section id=\"help_02\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">新規登録・パスワード再設定時に「メールを送る」ボタンを押したがメールが届かない</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">以下の原因が考えられますので、設定状況やメールフォルダをご確認ください。</p><ul class=\"p-help__list p-help__list--01\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">ドメイン「@mail.id.shueisha.co.jp」からのメールが受信拒否設定になっている</span><ul class=\"p-help__list\"><li>※ 受信設定方法はご利用の携帯電話やメールソフトにより異なります。</li></ul></li><li><span class=\"c-ttl--sub\">迷惑メールフォルダに振り分けられている</span></li><li><span class=\"c-ttl--sub\">１時間以内に何度も操作している</span><ul class=\"p-help__list\"><li>※ 確認コードの有効期限は１時間となります。期限内に同じ操作をされましてもお手続きいただけません。<br> 再度操作される場合は、１時間以上空けてから行ってください。</li></ul></li></ul><p class=\"p-help__txt\">受信拒否設定をされた状態で、何度も確認コード送信の操作をされた場合、自動で送信を停止する機能が作動する場合がございます。<br> 受信設定されてもメールが届かない場合は調査をいたしますので、コンタクトセンターにお問い合わせください。</p></div></div></section><section id=\"help_03\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">集英社IDでは、以下の条件に当てはまるメールアドレスはご登録いただけません。</h2><div class=\"p-help__answer\"><ul class=\"p-help__listnum p-help__listnum--01\"><li><span class=\"c-ttl--sub\">世界共通となるインターネット通信規格RFC（Request for Comments）に準拠していない</span><ul class=\"p-help__list p-help__list--01\" style=\"margin-top:1.5rem;\"><li>「.」を連続使用している場合</li><li>「.」を最初と最後(@の直前)に使っている場合</li></ul><p class=\"p-help__txt\">など</p></li><li><span class=\"c-ttl--sub\">無数にメールアドレスを生成できるメールアドレス（gmailのエイリアスやyahooのセーフティアドレス等）</span><ul class=\"p-help__list p-help__list--01\" style=\"margin:1.5rem 0;\"><li>gmailのエイリアスの例：aaa+bbb@gmail.com （＠の前に「+」が使われている）</li><li>yahooのセーフティアドレスの例：aaa-bbb@yahoo.co.jp （＠の前に「-」が使われている）</li></ul><p class=\"p-help__txt\">※gmailやyahooなどのフリーメール自体は引き続きご利用いただけます</p></li></ul></div></div></section><section id=\"help_04\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">メールに届いた確認コードとパスワードを入力しても次の画面に進みません</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">以下の原因であることが考えられます。</p><ul class=\"p-help__list p-help__list--01\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">確認コードが有効期限が切れている</span><ul class=\"p-help__list\"><li>※ 期限はメール送信から1時間以内となります。期限が切れている場合は最初からお手続きください。</li></ul></li><li><span class=\"c-ttl--sub\">入力された確認コードが間違っている</span></li><li><span class=\"c-ttl--sub\">パスワードが英大文字・英小文字・数字を含む半角英数字8文字以上の条件を満たしていない</span></li><li><span class=\"c-ttl--sub\">入力されたパスワードと確認用のパスワードが一致していない</span></li></ul><p class=\"p-help__txt\">また、新規登録のお手続きで確認コードのメールに記載されているURLから直接アクセスした場合、ご利用のパソコンやメールソフトによっては次のページに進まないことがございます。<br> この場合、記載されているURLアドレスを別のWebブラウザを開いて、アドレス欄に直接コピー＆ペーストし操作をお試しください。</p><p class=\"p-help__txt\">上記をお試しいただきましても、お手続きいただけない場合は、誤った情報入力によるキャッシュ（履歴）が残っている可能性がありますので、キャッシュクリア（履歴削除）をお試しください。<br> キャッシュクリアの方法は、ご利用のブラウザにより異なりますので、お調べいただきご操作をお願いいたします。</p></div></div></section>", 5)
const _hoisted_8 = {
  id: "help_05",
  class: "p-help__sec"
}
const _hoisted_9 = { class: "p-help__secin" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "ログインできない", -1)
const _hoisted_11 = { class: "p-help__answer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "メールアドレス、パスワードに誤りがないかご確認ください。", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "パスワードをお忘れの場合は、「パスワード再設定」からお手続きください。", -1)
const _hoisted_14 = {
  class: "p-help__txt",
  style: {"overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("＜パスワード再設定＞")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/reset_password")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "メールアドレス、パスワードに誤りがなくログインができない場合は、エラー内容等をコンタクトセンターへご連絡ください。", -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<section id=\"help_06\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">パスワードの設定がエラーになりできません</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">「英字大文字、英字小文字、数字を含む8文字以上」の条件に満たしているかご確認ください。</p><p class=\"p-help__txt\">条件に満たしたパスワードでもエラーになる場合は、エラー内容をコンタクトセンターへご連絡ください。</p></div></div></section><section id=\"help_07\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">確認コードを再送してほしい</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">最初のお手続きから１時間以上空けて再度お手続きください。</p><ul class=\"p-help__list\"><li>※ 新規会員登録時は確認コード発行から１時間は仮登録の状態となりますので、その間に同じメールアドレスで再度新規会員登録のお手続きいただきましても確認コードは送信されません。</li></ul></div></div></section>", 2)
const _hoisted_21 = {
  id: "help_08",
  class: "p-help__sec"
}
const _hoisted_22 = { class: "p-help__secin" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "「既に使用されているメールアドレス」と表示されて登録ができない", -1)
const _hoisted_24 = { class: "p-help__answer" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "以下の理由が考えれます。", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, [
  /*#__PURE__*/_createTextVNode("◆すでに集英社IDに登録がある"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※ご利用サービスの他に「HAPPY PLUS STORE」「HAPPY PLUS （ハピプラ）」「ジャンプキャラクターズストア」「ジャンプNAVI」「HAPPY PLUS ACADEMIA」「LEE」「年末年始 集英社マンガ祭」「UOMO」「週プレNEWS」「webスポルティーバ」「MEN'S NON-NO WEB」「リマコミ＋」「集英社オンライン」「Vジャンプ」「マンガMee」「集英社書籍」「別冊マーガレット」「SPUR」に登録がある")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", {
  class: "p-help__txt",
  style: {"margin-bottom":"4.5rem"}
}, "◆新規登録が完了しておらず、仮登録の状態である", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "以下の手順にてご確認・ご登録ください。", -1)
const _hoisted_29 = {
  class: "p-help__listnum",
  style: {"margin-bottom":"2.5rem"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "①集英社IDのサイトにログインする", -1)
const _hoisted_31 = { class: "p-help__list" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/login")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("li", { style: {"margin-bottom":"0px"} }, "※パスワードをお忘れの方は、パスワード再設定からお手続きください。", -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/reset_password")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "②マイページの「おすすめのサービス」から登録したいサービスを確認する")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "③「サービスを連携する」を押す")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "④該当サービスのサイトにページが移動したら、同じアカウント情報でログインし登録を完了させる")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, [
  /*#__PURE__*/_createTextVNode("①でログインができない、パスワード再設定のメールが届かない場合は、仮登録の状態であることが考えられます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 最後に操作してから1時間以上空けて、ご利用サービスより再度、新規登録をお試しください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※仮登録とは…お送りしたメールに記載の確認(認証)コードの入力または、会員情報登録がお済みでない状態")
], -1)
const _hoisted_39 = {
  id: "help_09",
  class: "p-help__sec"
}
const _hoisted_40 = { class: "p-help__secin" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "集英社IDから送られる「お知らせメール」を停止したい（配信停止）", -1)
const _hoisted_42 = { class: "p-help__answer" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "以下の手順で配信停止が可能です。", -1)
const _hoisted_44 = {
  class: "p-help__listnum",
  style: {"margin-bottom":"2.5rem"}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "①集英社IDのサイトにログインする", -1)
const _hoisted_46 = { class: "p-help__list" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/login")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "②マイページの右上にあるメニュー「・・・」を押す")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "③「メール受信許可」を押す")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "④集英社IDからのお知らせを「受信しない」に設定する")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "⑤入力内容を確認し、更新する")
], -1)
const _hoisted_52 = {
  id: "multi-authentication",
  class: "p-help__sec"
}
const _hoisted_53 = { class: "p-help__secin" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "多要素認証とは何ですか？", -1)
const _hoisted_55 = { class: "p-help__answer" }
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<p class=\"p-help__txt\">多要素認証とは、メールアドレスとパスワードによる通常のログインに加えて、お客様にあらかじめご登録いただいた認証用電話番号にSMSで届く「確認コード」を入力していただく、二段階の本人確認方法です。</p><ul class=\"p-help__list p-help__list--01\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">SMSの受信が可能な携帯電話番号を入力してください。</span></li><li><span class=\"c-ttl--sub\"> SMSは、ご登録いただいた携帯電話番号の通信事業者（MNO）に応じて、以下の送信元番号から送信されます。 </span><ul class=\"p-help__list p-help__list\" style=\"margin-top:1rem;\"><li>docomo : 0032064052</li><li>au : 0032064052</li><li>SoftBank : 244091</li><li>楽天モバイル : 0032064052</li><p style=\"margin-top:1rem;\">※2025年12月16日より、SMSの送信元表示名は「SHUEISHA」から上記番号表示に変更されました。</p></ul></li></ul>", 2)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<section id=\"multi-authentication_02\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">認証用電話番号とは何ですか？</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">お客様のアカウント・ログインIDを、第三者が不正に利用することを防止するために登録・ログインの際に必要な電話番号です。<br> 以下のサービスを利用するには、ログインID・パスワードによる認証のほか、携帯電話のSMSを利用しての認証が必要となります。<br> ■ 認証用電話番号の登録が必要なサービス </p><ul class=\"p-help__listnum\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">ジャンプNAVI</span></li><li><span class=\"c-ttl--sub\">ジャンプキャラクターズストア</span></li></ul></div></div></section><section id=\"multi-authentication_03\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">認証用電話番号が登録できません</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">認証用電話番号にご登録いただける携帯電話番号は、070、080、090で始まる電話番号のみとなっております。<br> 上記以外の番号（050から始まるIP電話番号、固定電話番号等）はご登録いただけませんので、あらかじめご了承ください。<br> また、一度登録された認証用電話番号を解除した場合や、退会をした場合は、一定期間同じ電話番号を登録することはできません。 </p></div></div></section><section id=\"multi-authentication_07\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">「この電話番号は使用できません」と表示され、認証用電話番号が登録できない</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">以下の理由が考えられます。</p><ul class=\"p-help__listnum\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">①同じ電話番号が、別の集英社ID（アカウント）で既に認証用電話番号として登録されている</span></li><li><span class=\"c-ttl--sub\">②認証用電話番号を解除、またはアカウントを退会してから、一定期間が経過していない</span></li></ul><p class=\"p-help__txt\">不正利用防止のため、認証用電話番号は複数のアカウントへ重複登録することはできません。<br>また、登録解除やアカウント退会後も、一定期間は同じ番号を再登録できません。</p><p class=\"p-help__txt\">■集英社IDに連携しているサービスのなかで、電話番号認証を導入しているサービスは以下となります。</p><ul class=\"p-help__listnum\" style=\"margin:1.5rem 0;\"><li><span class=\"c-ttl--sub\">・ジャンプNAVI</span></li><li><span class=\"c-ttl--sub\">・ジャンプキャラクターズストア</span></li></ul><p class=\"p-help__txt\">複数アカウントをお持ちの場合、すでに認証用電話番号の登録が完了しているアカウントにご希望のサービスを連携して、ご利用いただくことをご検討ください。<br>【サービス連携方法】</p><ul class=\"p-help__listnum\" style=\"margin:1.5rem 0;\"><li><span class=\"c-ttl--sub\">①集英社IDのサイトにログインする</span></li><li><span class=\"c-ttl--sub\">②「おすすめサービス」の中から、希望するサービスの「サービスを連携する」を押す</span></li><li><span class=\"c-ttl--sub\">③サービスのサイトから集英社IDのアカウント情報でログインする</span></li></ul><p class=\"p-help__txt\">なお、集英社IDはおひとり様1アカウントとしております。<br>複数のアカウントをお持ちの場合は、不要なアカウントの退会をお願いいたします。</p><p class=\"p-help__txt\">※アカウント退会後は、同一電話番号で再登録できるまで一定期間が必要です。ご了承のうえお手続きください。</p></div></div></section>", 3)
const _hoisted_61 = {
  id: "multi-authentication_04",
  class: "p-help__sec"
}
const _hoisted_62 = { class: "p-help__secin" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "認証用の電話番号を変更したい", -1)
const _hoisted_64 = { class: "p-help__answer" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, [
  /*#__PURE__*/_createTextVNode("現在登録されている認証用電話番号を解除したうえで、新しい電話番号を登録していただく必要があります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 以下の手順をご確認のうえお手続きください。 ")
], -1)
const _hoisted_66 = {
  class: "p-help__listnum",
  style: {"margin-bottom":"2.5rem"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "①集英社IDのサイトにログインする", -1)
const _hoisted_68 = { class: "p-help__list" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/login")
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<li><span class=\"c-ttl--sub\">②メニューの「認証用電話番号登録」を押す</span></li><li><span class=\"c-ttl--sub\">③表示されている電話番号を確認し「解除内容を確認する」を押す</span></li><li><span class=\"c-ttl--sub\">④表示されている電話番号にSMSで送られる確認コードを画面に入力し、「解除する」を押す</span></li><li><span class=\"c-ttl--sub\">⑤再度メニューの「認証用電話番号登録」を押す</span></li><li><span class=\"c-ttl--sub\">⑥新しい認証用電話番号を入力し、「入力内容を確認する」を押す</span></li><li><span class=\"c-ttl--sub\">⑦新しい電話番号にSMSで送られる確認コードを画面に入力し、「登録する」を押す</span></li>", 6)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "※登録されている電話番号が使用できず、確認コードを受け取ることができない場合は、コンタクトセンターまでお問い合わせください。", -1)
const _hoisted_77 = { class: "p-help__list" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/contact")
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<section id=\"multi-authentication_05\" class=\"p-help__sec\"><div class=\"p-help__secin\"><h2 class=\"p-help__ttl c-ttl\">SMSに確認コードが届かない場合はどうすればよいですか？</h2><div class=\"p-help__answer\"><p class=\"p-help__txt\">ご登録の携帯電話番号に誤りがないか、携帯電話のSMS受信拒否設定をご確認ください。 </p><ul class=\"p-help__listnum p-help__listnum--01\" style=\"margin-bottom:2.5rem;\"><li><span class=\"c-ttl--sub\">ご登録の携帯電話番号に誤りがないかご確認ください。</span></li><li><span class=\"c-ttl--sub\">ご契約の携帯電話回線でSMSサービスが利用できるかご確認ください。</span></li><li><span class=\"c-ttl--sub\"> 携帯電話でSMSの受信拒否設定をしている場合は、ご登録いただいた携帯電話番号の通信事業者（MNO）に応じて以下の番号の受信を許可してください。 </span><ul class=\"p-help__list p-help__list\" style=\"margin-top:1rem;\"><li>docomo : 0032064052</li><li>au : 0032064052</li><li>SoftBank : 244091</li><li>楽天モバイル : 0032064052</li><p style=\"margin-top:1rem;\">※2025年12月16日より、SMSの送信元表示名は「SHUEISHA」から上記番号表示に変更されました。</p></ul></li></ul><p class=\"p-help__txt\">各キャリアの受信拒否設定は以下で確認できます。</p><ul class=\"p-help__listnum\" style=\"margin-bottom:2.5rem;\"><li><ul class=\"p-help__list p-help__list--01\" style=\"margin:1.5rem 0;\"><li><span class=\"c-ttl--sub\"><a href=\"https://www.docomo.ne.jp/info/spam_mail/sms/index.html#p05\" style=\"text-decoration:underline;word-wrap:break-word;\" target=\"_blank\">docomo</a></span></li><li><span class=\"c-ttl--sub\"><a href=\"https://www.au.com/support/service/mobile/trouble/mail/cmail/block/\" style=\"text-decoration:underline;word-wrap:break-word;\" target=\"_blank\">au</a></span></li><li><span class=\"c-ttl--sub\"><a href=\"https://www.softbank.jp/mobile/support/mail/antispam/mms/whiteblack/\" style=\"text-decoration:underline;word-wrap:break-word;\" target=\"_blank\">SoftBank</a></span></li></ul><p class=\"p-help__txt\">上記以外はご利用のキャリアへお問い合わせください。</p></li></ul></div></div></section>", 1)
const _hoisted_80 = {
  id: "help_09",
  class: "p-help__sec"
}
const _hoisted_81 = { class: "p-help__secin" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h2", { class: "p-help__ttl c-ttl" }, "集英社IDを退会したい", -1)
const _hoisted_83 = { class: "p-help__answer" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "集英社IDを退会するためには、ご利用中の全てのサービスの連携解除（退会手続き）が必要です。", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "◆ご利用中サービスの連携解除方法", -1)
const _hoisted_86 = {
  class: "p-help__listnum p-help__listnum--01",
  style: {"margin-bottom":"2.5rem"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "集英社IDのサイトにログインする", -1)
const _hoisted_88 = { class: "p-help__list" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/login")
const _hoisted_90 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "マイページの「ご利用中のサービス」を確認する")
], -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "ご利用中のサービスの「サービス連携を解除する」からサービスサイトへアクセスし、退会する"),
  /*#__PURE__*/_createElementVNode("ul", { class: "p-help__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "※ご利用中のサービスがない場合は、「集英社ID退会方法」へお進みください。")
  ])
], -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "全てのサービスの退会手続き完了後に、集英社IDの退会手続きを行う")
], -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", { class: "p-help__txt" }, "◆集英社ID退会方法", -1)
const _hoisted_94 = {
  class: "p-help__listnum p-help__listnum--01",
  style: {"margin-bottom":"2.5rem"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "集英社IDのサイトにログインする", -1)
const _hoisted_96 = { class: "p-help__list" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode("https://id.shueisha.co.jp/login")
const _hoisted_98 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "スマートフォン：右上にある「・・・」から「退会する」を押す"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "パソコン   ：左メニュー最下部の「退会する」を押す")
], -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-ttl--sub" }, "「退会する」を押す")
], -1)

import { onMounted } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

const scrollToTarget = (elementId: string): void => {
    const el: HTMLElement | null = document.getElementById(elementId);
    el?.scrollIntoView({ behavior: "auto" });
};

// ページ読み込み時にハッシュがあればスクロール
onMounted(() => {
    if (window.location.hash) {
        const id: string = window.location.hash.replace("#", "");
        const el: HTMLElement | null = document.getElementById(id);
        el?.scrollIntoView({ behavior: "auto" });
    }
});



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("p", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createVNode(_component_router_link, {
                style: {"text-decoration":"underline","word-wrap":"break-word"},
                to: { name: 'ResetPassword' }
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _hoisted_18
          ])
        ])
      ]),
      _hoisted_19,
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("ul", _hoisted_29, [
              _createElementVNode("li", null, [
                _hoisted_30,
                _createElementVNode("ul", _hoisted_31, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'Login' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_33,
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'ResetPassword' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_35,
              _hoisted_36,
              _hoisted_37
            ]),
            _hoisted_38
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("ul", _hoisted_44, [
              _createElementVNode("li", null, [
                _hoisted_45,
                _createElementVNode("ul", _hoisted_46, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'Login' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_48,
              _hoisted_49,
              _hoisted_50,
              _hoisted_51
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("a", {
              href: "#multi-authentication_05",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (scrollToTarget('multi-authentication_05')), ["prevent"])),
              class: "custom-link-color"
            }, " ※※SMSに確認コードが届かない方はこちらをご確認ください。※※ ")
          ])
        ])
      ]),
      _hoisted_58,
      _createElementVNode("section", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createElementVNode("ul", _hoisted_66, [
              _createElementVNode("li", null, [
                _hoisted_67,
                _createElementVNode("ul", _hoisted_68, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'Login' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_69
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_70,
              _createElementVNode("li", null, [
                _hoisted_76,
                _createElementVNode("ul", _hoisted_77, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { path: '/contact' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_78
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_79,
      _createElementVNode("section", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _hoisted_85,
            _createElementVNode("ul", _hoisted_86, [
              _createElementVNode("li", null, [
                _hoisted_87,
                _createElementVNode("ul", _hoisted_88, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'Login' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_89
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_90,
              _hoisted_91,
              _hoisted_92
            ]),
            _hoisted_93,
            _createElementVNode("ul", _hoisted_94, [
              _createElementVNode("li", null, [
                _hoisted_95,
                _createElementVNode("ul", _hoisted_96, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      style: {"text-decoration":"underline","word-wrap":"break-word"},
                      to: { name: 'Login' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_97
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_98,
              _hoisted_99
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})